/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-shadow */
// https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope

export enum Spacing {
  Spacing1 = '0.6rem',
  Spacing2 = '1.2rem',
  Spacing3 = '1.8rem',
  Spacing4 = '2.4rem',
  Spacing5 = '3.0rem',
  Spacing6 = '3.6rem',
  Spacing7 = '4.2rem',
  Spacing8 = '4.8rem',
  Spacing9 = '5.4rem',
  Spacing10 = '6.0rem',
  Spacing11 = '6.6rem',
  Spacing12 = '7.2rem',
}

export enum SpacingSize {
  ExtraSmall = 12,
  Small = 30,
  Medium = 54,
  Large = 72,
}

export enum CardSpacing {
  ExtraSmall = 18,
  Small = 24,
  Medium = 30,
  Large = 36,
}
